import { createContext, useContext } from 'react';

/** Which side of the card the user clicked "+" on. */
export type WorkflowAddNodeDirection = 'downstream' | 'upstream';

/**
 * Opens the add-node modal wired to one of `flowNodeId`'s ports, so the step the
 * user picks lands already connected — after that card for `'downstream'`,
 * before it for `'upstream'`.
 *
 * Takes the *flow* node id (a trigger's is `trigger:<id>`, not a workflow node)
 * because the caller is a card on the canvas. Mapping that to a `connectFrom`
 * is the provider's job — see `connectFromForDroppedSource`.
 *
 * Provided by the editor canvas only. The run graph is read-only and leaves it
 * null, which is what suppresses the "+" ports there.
 */
export type WorkflowAddNodeFromSource = (
  flowNodeId: string,
  direction: WorkflowAddNodeDirection
) => void;

const WorkflowAddNodeFromSourceContext =
  createContext<WorkflowAddNodeFromSource | null>(null);

export const WorkflowAddNodeFromSourceProvider =
  WorkflowAddNodeFromSourceContext.Provider;

export const useWorkflowAddNodeFromSource =
  (): WorkflowAddNodeFromSource | null =>
    useContext(WorkflowAddNodeFromSourceContext);
